/* LOOKEE 2026 theme: core helpers shared by every page (toast, focus trap, scroll lock), the search overlay with
   predictive results, the in-app shopping bar and the account-page links. No libraries.
   Header, menus, cart, product form and gallery live in lk-v2.js and lk-pdp.js. */
(() => {
  const LK = window.LK || (window.LK = {});
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ------------------------------------------------------------ helpers */
  const toast = (msg) => {
    const t = $('.lk-toast');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(t._h);
    t._h = setTimeout(() => { t.hidden = true; }, 3200);
  };
  LK.toast = toast;

  const trapFocus = (container, onClose) => {
    const focusables = () => $$('a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select, textarea, [tabindex]:not([tabindex="-1"])', container).filter((el) => el.offsetParent !== null);
    const key = (e) => {
      if (e.key === 'Escape') { onClose(); return; }
      if (e.key !== 'Tab') return;
      const f = focusables();
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    container.addEventListener('keydown', key);
    return () => container.removeEventListener('keydown', key);
  };

  const lockScroll = (on) => {
    document.documentElement.style.overflow = on ? 'hidden' : '';
    if (LK.smooth) LK.smooth[on ? 'stop' : 'start']();
  };

  /* --------------------------------------------------------------- search */
  const initSearch = () => {
    const box = $('#lk-search');
    if (!box) return;
    const input = $('input[type="search"]', box);
    const results = $('[data-search-results]', box);
    const defaultHTML = results ? results.innerHTML : '';
    let release;
    let ctrl;
    const open = (opener) => {
      box.hidden = false;
      requestAnimationFrame(() => box.classList.add('is-open'));
      lockScroll(true);
      box._opener = opener;
      release = trapFocus(box, close);
      setTimeout(() => input && input.focus(), 50);
    };
    const close = () => {
      box.classList.remove('is-open');
      lockScroll(false);
      release && release();
      setTimeout(() => { box.hidden = true; }, 300);
      box._opener && box._opener.focus && box._opener.focus();
    };
    $$('[data-open-search]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); open(b); }));
    $$('[data-close]', box).forEach((b) => b.addEventListener('click', close));
    if (!input || !results) return;
    let timer;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (!q) { results.innerHTML = defaultHTML; return; }
      timer = setTimeout(async () => {
        ctrl && ctrl.abort();
        ctrl = new AbortController();
        try {
          const url = `${LK.routes.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,page,article,collection&resources[limit]=6&resources[options][unavailable_products]=last`;
          const res = await fetch(url, { signal: ctrl.signal });
          if (!res.ok) throw new Error(res.status);
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('[data-predictive]');
          results.innerHTML = inner ? inner.innerHTML : '';
        } catch (err) { if (err.name !== 'AbortError') results.innerHTML = defaultHTML; }
      }, 220);
    });
    input.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      const items = $$('.lk-search__item', results);
      if (!items.length) return;
      e.preventDefault();
      let i = items.findIndex((x) => x.getAttribute('aria-selected') === 'true');
      items.forEach((x) => x.setAttribute('aria-selected', 'false'));
      i = e.key === 'ArrowDown' ? Math.min(items.length - 1, i + 1) : Math.max(0, i - 1);
      items[i].setAttribute('aria-selected', 'true');
      items[i].focus();
    });
  };

  /* ------------------------------------------------- in-app shopping bar */
  const initInApp = () => {
    const bar = $('.lk-inapp');
    const path = LK.appShopPath || '/pages/lookee-app-shop';
    const params = new URLSearchParams(window.location.search);
    let flag = false;
    try {
      if (window.location.pathname.replace(/\/$/, '') === path.replace(/\/$/, '') || params.get('lk_app') === '1') sessionStorage.setItem('lkInApp', '1');
      flag = sessionStorage.getItem('lkInApp') === '1';
    } catch (e) { /* storage blocked */ }
    if (!bar || !flag) return;
    const onShop = window.location.pathname.replace(/\/$/, '') === path.replace(/\/$/, '');
    const back = $('[data-inapp-back]', bar);
    const shop = $('[data-inapp-shop]', bar);
    if (onShop) { back && (back.hidden = history.length < 2); shop && (shop.hidden = true); }
    back && back.addEventListener('click', () => { if (history.length > 1) history.back(); else window.location.href = path; });
    bar.hidden = false;
  };

  document.addEventListener('DOMContentLoaded', () => {
    initSearch();
    initInApp();
  });
})();

/* Account pages: the "Forgot your password?" link and the delete-address confirmation, without inline handlers */
(function () {
  document.addEventListener('click', function (e) {
    var r = e.target.closest && e.target.closest('[data-show-recover]');
    if (r) { var box = document.getElementById('recover'); if (box) box.hidden = false; }
    var b = e.target.closest && e.target.closest('[data-confirm]');
    if (b) {
      var msg = b.getAttribute('data-confirm');
      try { msg = JSON.parse(msg); } catch (er) {}
      if (!window.confirm(msg)) e.preventDefault();
    }
  });
})();
